export default function registerDropzone(Alpine) {
  Alpine.data("dropzone", (uploadUrl) => ({
    uploadUrl,
    dragging: false,
    uploading: false,

    handleDrop(event) {
      this.dragging = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.uploadFiles(files);
      }
    },

    handleFileSelect(event) {
      const files = event.target.files;
      if (files.length > 0) {
        this.uploadFiles(files);
      }
      event.target.value = "";
    },

    async uploadFiles(files) {
      this.uploading = true;
      const form = new FormData();
      for (const file of files) {
        form.append("files[]", file);
      }

      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

      try {
        const response = await fetch(this.uploadUrl, {
          method: "POST",
          headers: {
            "X-CSRF-Token": csrfToken,
            Accept: "text/vnd.turbo-stream.html, text/html"
          },
          body: form
        });

        if (response.ok) {
          window.Turbo.visit(window.location.href, { action: "replace" });
        }
      } finally {
        this.uploading = false;
      }
    }
  }));
}
